// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__fWnM6","home":"Breadcrumbs_home__Ectl5","item":"Breadcrumbs_item__5RgS-","link":"Breadcrumbs_link__kgrHI"};